import React, {Component} from "react";
import {Table} from "react-bootstrap";
import headerLogo from "./../img/sadat logo-png.png";
import {downloadCsv} from "../utils/csvExport";

const sortByUnitThenRoom = (list) => [...list].sort((a, b) => {
    const unitCmp = String(a.unit ?? a.unitNumber ?? '').localeCompare(
        String(b.unit ?? b.unitNumber ?? ''), undefined, {numeric: true});
    if (unitCmp !== 0) return unitCmp;
    return String(a.room ?? a.roomNumber ?? '').localeCompare(
        String(b.room ?? b.roomNumber ?? ''), undefined, {numeric: true});
});

class PrintReports extends Component {
    static getDerivedStateFromProps(props, state) {
        const residenceFilter = props.residenceStatusFilter || state?.residenceStatusFilter || '';
        let reports = Array.isArray(props.report) ? [...props.report] : [];
        if (residenceFilter) {
            reports = reports.filter((r) =>
                (r.personType && r.personType === residenceFilter) ||
                (r.accommodation && r.accommodation === residenceFilter)
            );
        }
        reports = sortByUnitThenRoom(reports);
        return {
            residenceStatusFilter: residenceFilter,
            cleaningReport: reports.filter((report) => report.title === "cleaning"),
            delayInArrivalReport: reports.filter((report) => report.title === "delayInArrival"),
            exitReport: reports.filter((report) => report.title === "exit" || report.title === "exitSecondary"),
            violationReport: reports.filter((report) => report.title === "violation"),
            penaltyReport: reports.filter((report) => report.title === "penalty"),
            dischargeReport: reports.filter((report) => report.title === "discharge"),
            cancelContractReport: reports.filter((report) => report.title === "cancelContract"),
            workReport: reports.filter((report) => report.title === "workReport"),
        }
    };

    exportExcel = () => {
        const personName = this.props.personName || '';
        const headers = ['نوع', 'نام', 'تاریخ', 'از تاریخ', 'تا تاریخ', 'ساعت', 'شرح', 'مبلغ', 'آدرس مقصد', 'تلفن مقصد', 'نسبت'];
        const rows = [];
        const push = (titleFa, r) => {
            rows.push([
                titleFa,
                personName || r.guestName || '',
                r.date || '',
                r.startDate || '',
                r.endDate || '',
                r.hour || '',
                r.description || '',
                r.penaltyAmount || r.returnedAmount || '',
                r.destinationAddress || '',
                r.destinationPhoneNumber || '',
                r.relation || '',
            ]);
        };
        (this.state.cleaningReport || []).forEach((r) => push('نظافت', r));
        (this.state.delayInArrivalReport || []).forEach((r) => push('تاخیر ورود', r));
        (this.state.exitReport || []).forEach((r) => push(r.title === 'exitSecondary' ? 'خروج دوم' : 'خروج', r));
        (this.state.violationReport || []).forEach((r) => push('تخلف', r));
        (this.state.penaltyReport || []).forEach((r) => push('جریمه', r));
        (this.state.dischargeReport || []).forEach((r) => push('تخلیه', r));
        (this.state.cancelContractReport || []).forEach((r) => push('لغو قرارداد', r));
        (this.state.workReport || []).forEach((r) => push('گزارش کار', r));
        downloadCsv(`reports-${personName || 'export'}.csv`, headers, rows);
    };

    render() {
        const personName = this.props.personName || '';
        const hasResidenceMeta = (this.props.report || []).some((r) => r.personType || r.accommodation);
        return (
            <div className="tabs-content" style={{direction: "rtl"}}>
                <div className={"text-center"}><img src={headerLogo} width={200} height={200} style={{marginTop: "-50px", marginBottom: "-50px"}}/></div>
                <div className={"mb-5 d-flex justify-content-between align-items-center px-2"} style={{fontSize: '1.5rem', fontWeight: '600'}}>
                    <span>گزارش ها</span>
                    <button type="button" className="btn btn-sm btn-outline-success" onClick={this.exportExcel}>
                        خروجی اکسل
                    </button>
                </div>
                {hasResidenceMeta ? (
                    <div className="mb-3 mx-2">
                        <label className="me-2">وضعیت اقامت:</label>
                        <select
                            value={this.state.residenceStatusFilter || ''}
                            onChange={(e) => this.setState({residenceStatusFilter: e.target.value})}
                        >
                            <option value="">همه</option>
                            <option value="constant">اقامتگر ثابت</option>
                            <option value="familyGuest">بستگان درجه یک</option>
                            <option value="otherGuest">متفرقه</option>
                        </select>
                    </div>
                ) : null}
                <div className={"mx-2"}>
                    {
                        this.state.cleaningReport.length !== 0 ?
                        <>
                            <h5 className={"text-center my-4"}>نوبت نظافت شبانه</h5>
                            <div>
                                <Table>
                                    <thead>
                                    <tr>
                                        <th>تاریخ</th>
                                        <th>مبلغ</th>
                                        <th>توضیحات</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        this.state.cleaningReport.map((c, i) => (
                                            <tr key={c.id || i}>
                                                <td>{c.date}</td>
                                                <td>{c.penaltyAmount || '—'}</td>
                                                <td>{c.description}</td>
                                            </tr>
                                        ))
                                    }
                                    </tbody>
                                </Table>
                            </div>
                        </> : null
                    }
                    {
                        this.state.delayInArrivalReport.length !== 0 ?
                        <>
                            <h5 className={"text-center my-4"}>تأخیر در ورود</h5>
                            <div>
                                <Table>
                                    <thead>
                                    <tr>
                                        <th>تاریخ</th>
                                        <th>ساعت</th>
                                        <th>عملیات</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        this.state.delayInArrivalReport.map((d, i) => (
                                            <tr key={d.id || i}>
                                                <td>{d.date}</td>
                                                <td>{d.hour}</td>
                                            </tr>
                                        ))
                                    }
                                    </tbody>
                                </Table>
                            </div>
                        </> : null
                    }
                    {
                        this.state.exitReport.length !== 0 ?
                        <>
                            <h5 className={"text-center my-4"}>خروج</h5>
                            <div>
                                <Table>
                                    <thead>
                                    <tr>
                                        <th>از تاريخ</th>
                                        <th>تا تاريخ</th>
                                        <th>آدرس مقصد</th>
                                        <th>شماره تماس مقصد</th>
                                        <th>نسبت</th>
                                        <th>نوع</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        this.state.exitReport.map((e, i) => (
                                            <tr key={e.id || i}>
                                                <td>{e.startDate}</td>
                                                <td>{e.endDate}</td>
                                                <td>{e.destinationAddress}</td>
                                                <td>{e.destinationPhoneNumber}</td>
                                                <td>{e.relation}</td>
                                                <td>{e.title === 'exitSecondary' ? 'خروج دوم' : 'خروج'}</td>
                                            </tr>
                                        ))
                                    }
                                    </tbody>
                                </Table>
                            </div>
                        </> : null
                    }
                    {
                        this.state.workReport && this.state.workReport.length !== 0 ?
                        <>
                            <h5 className={"text-center my-4"}>گزارش کار روزانه</h5>
                            <div>
                                <Table>
                                    <thead>
                                    <tr>
                                        <th>تاریخ</th>
                                        <th>شرح</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        this.state.workReport.map((w, i) => (
                                            <tr key={w.id || i}>
                                                <td>{w.date}</td>
                                                <td>{w.description}</td>
                                            </tr>
                                        ))
                                    }
                                    </tbody>
                                </Table>
                            </div>
                        </> : null
                    }
                    {
                        this.state.violationReport.length !== 0 ?
                            <>
                                <h5 className={"text-center my-4"}>ثبت تخلف</h5>
                                <div>
                                    <Table>
                                        <thead>
                                        <tr>
                                            <th>گزارش تخلف</th>
                                            <th>تاریخ</th>
                                            <th>ساعت</th>
                                            <th>عملیات</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            this.state.violationReport.map((v, i) => (
                                                <tr key={v.id || i}>
                                                    <td>{v.description}</td>
                                                    <td>{v.date}</td>
                                                    <td>{v.hour}</td>
                                                </tr>
                                            ))
                                        }
                                        </tbody>
                                    </Table>
                                </div>
                            </> : null
                    }
                    {
                        this.state.penaltyReport.length !== 0 ?
                        <>
                            <h5 className={"text-center my-4"}>ثبت جریمه</h5>
                            <div>
                                <Table>
                                    <thead>
                                    <tr>
                                        <th>نوع جریمه</th>
                                        <th>مقدار جریمه</th>
                                        <th>دلیل جریمه</th>
                                        <th>عملیات</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        this.state.penaltyReport.map((p, i) => (
                                            <tr key={p.id || i}>
                                                <td>{p.penaltyType === "financial" ? ("نقدی") : ("تنبیهی")}</td>
                                                <td>{p.penaltyAmount}</td>
                                                <td>{p.description}</td>
                                            </tr>
                                        ))
                                    }
                                    </tbody>
                                </Table>
                            </div>
                        </> : null
                    }
                    {
                        this.state.dischargeReport.length !== 0 ?
                        <>
                            <h5 className={"text-center my-4"}>اعلام تخلیه</h5>
                            <div>
                                <Table>
                                    <thead>
                                    <tr>
                                        <th>نام اقامتگر</th>
                                        <th>تاریخ اعلام تخلیه</th>
                                        <th>تاریخ تخلیه</th>
                                        <th>تاریخ عودت ودیعه</th>
                                        <th>کسر ضرر و زیان</th>
                                        <th>علت کسر ضر و زیان</th>
                                        <th>مبلغ قابل عودت</th>
                                        <th>عملیات</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        this.state.dischargeReport.map((d, i) => (
                                            <tr key={d.id || i}>
                                                <td>{personName || d.guestName || ''}</td>
                                                <td>{d.startDate}</td>
                                                <td>{d.endDate}</td>
                                                <td>{d.date}</td>
                                                <td>{d.penaltyAmount}</td>
                                                <td>{d.description}</td>
                                                <td>{d.returnedAmount}</td>
                                            </tr>
                                        ))
                                    }
                                    </tbody>
                                </Table>
                            </div>
                        </> : null
                    }
                    {
                        this.state.cancelContractReport.length !== 0 ?
                        <>
                            <h5 className={"text-center my-4"}>لغو قرارداد</h5>
                            <div>
                                <Table>
                                    <thead>
                                    <tr>
                                        <th>نام اقامتگر</th>
                                        <th>تاریخ</th>
                                        <th>علت</th>
                                        <th>کسر ضرر و زیان</th>
                                        <th>مبلغ قابل عودت</th>
                                        <th>عملیات</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        this.state.cancelContractReport.map((cc, i) => (
                                            <tr key={cc.id || i}>
                                                <td>{personName || cc.guestName || ''}</td>
                                                <td>{cc.date}</td>
                                                <td>{cc.description}</td>
                                                <td>{cc.penaltyAmount}</td>
                                                <td>{cc.returnedAmount}</td>
                                            </tr>
                                        ))
                                    }
                                    </tbody>
                                </Table>
                            </div>
                        </> : null
                    }
                </div>
            </div>
        );
    }
}

export default PrintReports
